import { incomeCategoryAddApi } from "../../api/incomeCategory/incomeCategoryAddApi"

type PayloadShape = Parameters<typeof incomeCategoryAddApi>[0]

export async function incomeCategoryAddService(payload: PayloadShape, token: string) {
	return await incomeCategoryAddApi(payload, token)
}
